<h1 matDialogTitle>{{'audit-submission.signature-title' | translate}}</h1>
<mat-dialog-content>
  <canvas #canvas id="signature-canvas"></canvas>
  <p>{{'audit-submission.signature-hint' | translate}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button class="dialog-btn-left" color="primary" matDialogClose><mat-icon>clear</mat-icon> {{'cancel' | translate}}</button>
  <button mat-raised-button class="dialog-btn-right" color="accent" (click)="save()" [disabled]="!signed"><mat-icon>check</mat-icon> {{'confirm' | translate}}</button>
</mat-dialog-actions>
